/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function DeliveryProfilesPropertiesEditViewController(this: JS5Object, _: JS5Object, $routeParams: JS5Object, $route: JS5Object,
                                                      $location: JS5Object, PartnerEditService: JS5Object, uiGridConstants: JS5Object,
                                                      ModalService: JS5Object, NotificationService: JS5Object,
                                                      MediaAcceptProfileService: JS5Object, BreadcrumbService: JS5Object,
                                                      UtilsService: JS5Object, SidebarService: JS5Object, $timeout: JS5Function, $q: JS5Object,
                                                      PackageAcceptTemplatesService: JS5Object, PackagePropertiesQueryService: JS5Object) {
    this.editData = {};
    const getData = () => {
        this.loadingIndicator.show = true;
        let promises = {
            availablePackageAcceptTemplates: PackageAcceptTemplatesService.getPackageAcceptTemplates({view: 'EXTENDED'}),
            availableCategoryTypes: PackagePropertiesQueryService.getCategories(),
            existingDeliveryProfilesForPartner: PartnerEditService.getDeliveryProfilesForPartner($routeParams.id)
        };

        if ($routeParams.deliveryProfileId !== '-1') {
            _.set(promises, 'deliveryProfile', PartnerEditService.getDeliveryProfile($routeParams.deliveryProfileId));
        }

        $q.all(promises).then((data: JS5Object) => {
            PartnerEditService.originalDeliveryProfileData = _.cloneDeep(data.deliveryProfile);
            this.editData = data.deliveryProfile;
            this.availablePackageAcceptTemplates = data.availablePackageAcceptTemplates;
            this.availableCategoryTypes = data.availableCategoryTypes;
            this.existingDeliveryProfilesForPartner = data.existingDeliveryProfilesForPartner;

            this.selectedPackageAcceptTemplateInUseError = {
                message: `This Package Accept Template as it is already in use for this this Partner.)`,
                type: 'error'
            };
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    const saveHandler = () => {
        this.loadingIndicator.show = true;
        if ($routeParams.deliveryProfileId === '-1') {
            saveNewDeliveryProfile();
        } else {
            updateDeliveryProfile();
        }
    };

    const updateDeliveryProfile = () => {
        PartnerEditService.updateDeliveryProfile(this.editData).then((deliveryProfile: JS5Object) => {
            PartnerEditService.originalDeliveryProfileData = _.cloneDeep(deliveryProfile);
            this.editData = deliveryProfile;
            this.editorForm.$setPristine();
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    const saveNewDeliveryProfile = () => {
        PartnerEditService.createDeliveryProfile($routeParams.id, this.editData).then((deliveryProfile: JS5Object) => {
            PartnerEditService.originalDeliveryProfileData = _.cloneDeep(deliveryProfile);
            this.editData = deliveryProfile;
            $route.updateParams({deliveryProfileId: deliveryProfile.id});
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: () => !_.get(this.editorForm, '$pristine')
                && _.has(this.editData, 'packageAcceptTemplate')
                && _.has(this.editData, 'categoryType')
                && !this.selectedPackageAcceptTemplateInUse(),
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: () => !_.get(this.editorForm, '$pristine'),
            onClick: () => {
                this.editData = _.cloneDeep(PartnerEditService.originalDeliveryProfileData);
                this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: () => !_.get(this.editorForm, '$dirty'),
            onClick: () => $location.url(`/system/partners/edit/${$routeParams.id}/deliveryProfiles`)
        }
    ];

    this.$onInit = () => {
        SidebarService.editService = PartnerEditService;

        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        getData();

    };

    this.selectedPackageAcceptTemplateInUse = () => {
        let selectedPATId = _.get(this.editData, 'packageAcceptTemplate.id');
        let selectedPATChanged = selectedPATId !== _.get(PartnerEditService, 'originalDeliveryProfileData.packageAcceptTemplate.id');
        let patInUse = _.some(this.existingDeliveryProfilesForPartner, {
            packageAcceptTemplate: {
                id: selectedPATId
            }
        });

        return selectedPATChanged && patInUse;
    };

    this.$onDestroy = () => {
        PartnerEditService.originalDeliveryProfileData = null;
        PartnerEditService.viewData = null;
    };

    this.$postLink = () => {
        $timeout(() => {
            PartnerEditService.editorForm = this.editorForm;
            BreadcrumbService.editService = PartnerEditService;
        });
    };
}


angular.module('prism-ui.deliveryProfiles').component('deliveryProfilesPropertiesEditView', {
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/properties/delivery-profiles-properties-edit-view-template.html',
    controller: DeliveryProfilesPropertiesEditViewController
});
